<template>
  <div class="password-recover">
    <form class="password-recover__form" @submit.prevent="submit">
      <AppControl
        label="E-mail"
        class="password-recover__control"
        :error="getError('email')"
      >
        <AppInput
          v-model="$v.form.email.$model"
          class="password-recover__input"
          :invalid="isInvalid('email')"
          placeholder="Введите E-mail"
          theme="third"
          type="email"
        />
      </AppControl>

      <p class="password-recover__message">{{ message }}</p>

      <AppBtn
        type="submit"
        class="password-recover__submit"
        color="third"
        :loading="loading"
      >
        Отправить
      </AppBtn>
    </form>
  </div>
</template>

<script>
import AppControl from "@/components/ui/control/AppControl.vue";
import { getValidationMessage } from "@utils/validation-messages";
import { required, email } from "vuelidate/lib/validators";
import { requestAlert, showAlert } from "@/core/common/";
import { asyncModal } from "@/components/ui/modal/";
import service from "@/services/auth";

const defaultForm = () => ({
  email: ""
});

const PasswordRecover = {
  name: "PasswordRecover",

  components: {
    AppControl
  },

  data: () => ({
    form: defaultForm(),
    loading: false,
    message: ""
  }),

  validations: {
    form: {
      email: { required, email }
    }
  },

  methods: {
    getError(field) {
      return getValidationMessage(this.$v.form[field]);
    },

    isInvalid(field) {
      return this.$v.form[field].$error;
    },

    async submit() {
      if (this.loading) return;
      this.$v.$touch();
      this.message = "";
      if (this.$v.$invalid) return;
      this.loading = true;

      try {
        const { success, message } = await service.resetPasswordRequest(
          this.form.email
        );
        if (success) {
          this.$modals.close(this);
          showAlert(message);
        } else {
          this.message = message;
        }
      } catch {
        requestAlert();
      }

      this.loading = false;
    }
  }
};

export default PasswordRecover;

export function openModal() {
  return asyncModal({
    name: "password-recover-modal",
    component: PasswordRecover,
    title: "Восстановление пароля"
  });
}
</script>

<style lang="scss">
.password-recover {
  width: 470px;
  max-width: 100%;
  margin: 0 auto;
  padding-bottom: 15px;

  &__control {
    margin-bottom: 25px;
  }

  &__submit {
    width: 265px;
    height: 55px;
    text-transform: uppercase;
    margin: 0 auto;
    display: flex;
    font-size: 24px;
  }

  &__input {
    font-weight: bold;
    height: 60px;
    font-size: 20px;
    text-transform: uppercase;
  }

  &__message {
    text-align: center;
    margin-bottom: 20px;
    height: 18px;
  }
}
</style>
